import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import useAnalyticsManager from "@/hooks/miscellaneous/useAnalyticsManager";

type LinkTopNavItem = {
  isLink: true;
  href: string;
  icon?: string;
};

type ExpandableTopNavItem = {
  isLink: false;
  data: Array<string>;
  icon?: string;
};

type GeneralProps = {
  label: string;
};

export type TopNavItem = GeneralProps & (LinkTopNavItem | ExpandableTopNavItem);

// Mirrors TS-loom NavbarSection + NavbarItems exactly (gap-1 row, padded
// uppercase links, active item underlined with the accent).
const TopNavBar: React.FC<{
  navBarItems: TopNavItem[];
  className?: string;
}> = ({ navBarItems, className }) => {
  const location = useLocation();
  const path = location.pathname;
  const { sendEvent } = useAnalyticsManager();

  return (
    <div className={cn("flex items-center gap-1", className)}>
      {navBarItems.map((item) => {
        if (!item.isLink) return null;
        const active = path === item.href;
        return (
          <Link
            key={item.label}
            to={item.href}
            onClick={() =>
              sendEvent("navigation_tab_clicked", { tab_name: item.label })
            }
            className={cn(
              "relative px-4 py-2 font-mono text-[11px] uppercase tracking-[0.22em] transition-colors",
              active
                ? "border-b border-[var(--color-accent)] text-[var(--color-text)]"
                : "text-[var(--color-text-muted)] hover:text-[var(--color-text)]"
            )}
          >
            <span>{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default TopNavBar;
